$(function () {
  $(document).on(
    "click",
    ".u_klarna_close_btn,.u_klarna_popup_overlay,.u_klarna_popup_cross",
    function (e) {
      e.preventDefault()
      $(".u_klarna_popup_wrapper").hide()
      $("html").removeClass("body_overflow")
    }
  )
  $(document).on("click", ".u_klarna_link", function (e) {
    e.preventDefault()
    $(".u_klarna_popup_wrapper").show()
    $("html").addClass("body_overflow")
  })
  $(document).on("click", ".quantity-arrow-minus", function () {
    let inp_val = parseInt($(this).parent().find(".quantity-num").attr("value"))
    let min_qty = parseInt(
      $(this).parent().find(".quantity-num").attr("min-qty")
    )
    if (inp_val != "" && min_qty != "") {
      if (inp_val == min_qty) {
        $(".quantity-num").val(min_qty)
        $(".quantity-num").attr("value", min_qty)
        if ($(".u_min_order_text").text() != "") {
          $(".u_var_min_order_wrapper").fadeIn()
          setTimeout(function () {
            $(".u_var_min_order_wrapper").fadeOut()
          }, 3000)
        }
      } else {
        let count = --inp_val
        $(".quantity-num").attr("value", count)
      }
    }
  })
  $(document).on("click", ".quantity-arrow-plus", function () {
    let inp_val = parseInt($(this).parent().find(".quantity-num").attr("value"))
    let min_qty = parseInt(
      $(this).parent().find(".quantity-num").attr("min-qty")
    )
    let count = ++inp_val
    $(".quantity-num").attr("value", count)
  })
})
$(function () {
  let stock_in = "false"
  let var_sold_out = "false"
  let var_pre_order = "false"
  $(".u_master_select option").each(function () {
    if ($(this).attr("data-iq") > 0) {
      stock_in = "true"
      return false
    }
  })
  $(".u_master_select option").each(function () {
    if (
      parseInt($(this).attr("data-iq")) < 0 &&
      $(this).attr("data-ip") == "continue"
    ) {
      var_pre_order = "true"
      return false
    }
  })
  $(".u_master_select option").each(function () {
    if (
      parseInt($(this).attr("data-iq")) < 1 &&
      $(this).attr("data-ip") == "deny"
    ) {
      var_sold_out = "true"
      return false
    }
  })
  if (
    (stock_in == "true" && var_pre_order == "true" && var_sold_out == "true") ||
    (stock_in == "true" &&
      var_pre_order == "true" &&
      var_sold_out == "false") ||
    (stock_in == "true" &&
      var_pre_order == "false" &&
      var_sold_out == "false") ||
    (stock_in == "true" && var_pre_order == "false" && var_sold_out == "true")
  ) {
    $(".u_master_select option").each(function () {
      let master = $(this)
      let m_val
      let master_title = $(this).attr("data-title").trim().toLowerCase()
      $(".u_custom_variant").each(function () {
        let custom_title = $(this).attr("date-title").trim()
        if (master_title == custom_title) {
          if (parseInt($(master).attr("data-iq")) > 0) {
            m_val = parseInt($(master).attr("data-iq"))
            return false
          }
        }
      })
      if (typeof m_val != "undefined") {
        return false
      }
    })
  }
  if (
    (stock_in == "false" &&
      var_pre_order == "true" &&
      var_sold_out == "true") ||
    (stock_in == "false" &&
      var_pre_order == "true" &&
      var_sold_out == "true") ||
    (stock_in == "false" && var_pre_order == "true" && var_sold_out == "false")
  ) {
    $(".u_master_select option").each(function () {
      let master = $(this)
      let m_val
      let master_title = $(this).attr("data-title").trim().toLowerCase()
      $(".u_custom_variant").each(function () {
        let custom_title = $(this).attr("date-title").trim()
        if (master_title == custom_title) {
          if (
            parseInt($(master).attr("data-iq")) < 0 &&
            $(master).attr("data-ip") == "continue"
          ) {
            m_val = parseInt($(master).attr("data-iq"))
            $(this).attr("checked", "checked")
            return false
          }
        }
      })
      if (typeof m_val != "undefined") {
        return false
      }
    })
  }
  if (
    stock_in == "false" &&
    var_pre_order == "false" &&
    var_sold_out == "true"
  ) {
    $(".u_master_select option").each(function () {
      let master = $(this)
      let m_val
      let master_title = $(this).attr("data-title").trim().toLowerCase()
      $(".u_custom_variant").each(function () {
        let custom_title = $(this).attr("date-title").trim()
        if (master_title == custom_title) {
          if (
            parseInt($(master).attr("data-iq")) < 1 &&
            $(master).attr("data-ip") == "deny"
          ) {
            m_val = parseInt($(master).attr("data-iq"))
            $(this).attr("checked", "checked")
            return false
          }
        }
      })
      if (typeof m_val != "undefined") {
        return false
      }
    })
  }
})
$(function () {
  swatches()
  let c_head = $(".trustpilot-widget iframe").contents().find("head")
  let css =
    "<style>.tp-widget-wrapper .wrapper-company-stars{justify-content: flex-end;flex-direction: column; !immportant}</style>"
  $(c_head).append(css)
})

$(".u_custom_variant").change(function () {
  swatches()
})
function swatches() {
  $(".u_custom_variant:checked").each(function () {
    // klarna message
    let val_price = parseInt($(this).attr("data-price"))
    let f_price = val_price / 4
    $(".u_klarna_msg_size").text(
      `Make 4 payments of ${Shopify.formatMoney(f_price)} No fees.`
    )
    let min_qty = $(this).parent().find(".u_var_min_qty").text()
    let min_qty_text = $(this).parent().find(".u_var_min_qty_text").text()
    if (min_qty != "") {
      $(".quantity-num").val(min_qty)
      $(".quantity-num").attr("value", min_qty)
      $(".quantity-num").attr("min-qty", min_qty)
      $(".u_min_order_text").text(min_qty_text)
      $(".u_var_min_qty_line").attr("name", "properties[_Minimum_quantity]")
      $(".u_var_min_qty_line").val(min_qty)
      if (min_qty_text != "") {
        $(".u_var_min_qty_msg").attr(
          "name",
          "properties[_Minimum_quantity_msg]"
        )
        $(".u_var_min_qty_msg").val(min_qty_text)
      } else {
        $(".u_var_min_qty_msg").attr("name", "quantity_msg")
        $(".u_var_min_qty_msg").val("")
      }
    } else {
      $(".quantity-num").val(1)
      $(".quantity-num").attr("value", 1)
      $(".quantity-num").removeAttr("min-qty")
      $(".u_min_order_text").empty()
      $(".u_var_min_qty_line").attr("name", "quantity")
      $(".u_var_min_qty_msg").attr("name", "quantity_msg")
      $(".u_var_min_qty_line").val("")
      $(".u_var_min_qty_msg").val("")
      $(".u_var_min_order_wrapper").hide()
    }
    var c_t = $(this).attr("date-title").trim()
    $(".product-form__variants option").each(function () {
      let m_select_title = $(this).text().toLowerCase().trim()
      if (m_select_title == c_t) {
        $(".product-form__variants, .u_master_select")
          .val($(this).val())
          .trigger("change")
      }
    })
    let url = $(this).val()
    let av = $(this)
      .next()
      .find(".u_pro_variant_stock span")
      .hasClass("u_outstck")
      ? false
      : true
    if (av) {
      $(".product-form__cart-submit").removeAttr("aria-disabled")
      $(".product-form__cart-submit").attr("aria-label", "Add to basket")
      $("[data-add-to-cart-text]").text("Add to basket")
    } else {
      $(".product-form__cart-submit").attr("aria-disabled", "true")
      $(".product-form__cart-submit").attr("aria-label", "Sold out")
      $("[data-add-to-cart-text]").text("Sold out")
    }
    if (
      $(this).parent().find(".u_pro_variant_stock span").hasClass("ccpreorder")
    ) {
      $(".product-form__cart-submit").attr("data-preorder", "true")
    } else {
      $(".product-form__cart-submit").attr("data-preorder", "false")
    }
  })
}
